export default __webpack_public_path__ + "static/media/Overnight_Study_16_9.ff9d54f0.png";